export default __webpack_public_path__ + "static/media/gojo.1618d3c4.jpg";